import React from 'react';
import { Box, Link, Tooltip, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { InvoicesRoutes } from '../../../../Router/path';
import { useReservationInvoicesLookupQuery } from '../../Service/reservationInvoicesLookupApi';

const resolveCurrency = (currency?: string | null): string =>
  currency?.trim().toUpperCase() || 'PLN';

interface ReservationInvoiceLinksCellProps {
  reservationId: number;
}

const ReservationInvoiceLinksCell: React.FC<ReservationInvoiceLinksCellProps> = ({
  reservationId,
}) => {
  const { invoices, isLoading, isError, errorMessage } = useReservationInvoicesLookupQuery(
    reservationId
  );

  if (isLoading && invoices.length === 0) {
    return (
      <Typography variant="caption" color="text.secondary">
        Ładowanie...
      </Typography>
    );
  }

  if (isError) {
    return (
      <Typography variant="caption" color="error">
        {errorMessage ?? 'Nie udało się pobrać powiązanych faktur.'}
      </Typography>
    );
  }

  if (invoices.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary">
        -
      </Typography>
    );
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0.25 }}>
      {invoices.map((invoice) => (
        <Tooltip key={invoice.id} title={invoice.typeLabel} placement="top-start">
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0.25 }}>
            <Link
              component={RouterLink}
              to={InvoicesRoutes.update.replace(':invoiceId', String(invoice.id))}
              underline="hover"
              variant="body2"
              sx={{ lineHeight: 1.35, wordBreak: 'break-word' }}
            >
              {invoice.number}
            </Link>
            <Typography variant="caption" color="text.secondary">
              {invoice.totalGross !== null
                ? `${invoice.totalGross.toFixed(2)} ${resolveCurrency(invoice.currency)}`
                : '-'}
            </Typography>
          </Box>
        </Tooltip>
      ))}
    </Box>
  );
};

export default ReservationInvoiceLinksCell;
